export default __webpack_public_path__ + "static/char-53-anr-5e5fcd8595caaba8ebab56b14f88c700.gif";